export default __webpack_public_path__ + "static/media/vaatwasser.1baae48e.pdf";